import React from 'react';
import { PhoneIcon } from 'lucide-react';
export function CTABanner() {
  return <section id="contact" className="bg-brand-red py-20 px-6 text-center" data-id="element-35">
      <div className="container mx-auto max-w-4xl" data-id="element-36">
        <h2 className="text-white font-bold uppercase tracking-wider text-3xl md:text-4xl lg:text-5xl mb-6" data-id="element-37">
          Ready to Make Your Pool Shine?
        </h2>
        <p className="text-white/90 text-xl mb-10" data-id="element-38">
          Get a free, no-obligation quote today.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-6" data-id="element-39">
          <a href="tel:4802583707" className="bg-white text-brand-red hover:bg-gray-100 rounded-lg px-10 py-4 text-xl font-bold transition-colors w-full sm:w-auto shadow-lg flex items-center justify-center gap-3" data-id="element-40">
            <PhoneIcon className="w-6 h-6" data-id="element-41" />
            (480) 258-3707
          </a>
          <a href="mailto:redlinepooltile@gmail.com" className="bg-transparent border-2 border-white text-white hover:bg-white/10 rounded-lg px-10 py-4 text-xl font-bold transition-colors w-full sm:w-auto" data-id="element-42">
            Email Us
          </a>
        </div>
      </div>
    </section>;
}